module.exports = __webpack_public_path__ + "static/img/accessibility.eed6496.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/accessibility.png
// module id = ue0/
// module chunks = 1